import { DashboardSmallUser } from 'api';

export type DateShortcut = {
  value: string;
  label: string;
  start: Date;
  end: Date;
};

const formatDate = (date: Date) =>
  date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });

export const getMonthOptions = (now: Date): DateShortcut[] =>
  Array.from({ length: 12 }, (_, index) => {
    const start = new Date(now.getFullYear(), now.getMonth() - index, 1);
    const isCurrentMonth = index === 0;
    const end = isCurrentMonth
      ? new Date(now)
      : new Date(start.getFullYear(), start.getMonth() + 1, 0, 23, 59, 59, 999);
    return {
      value: `${start.getFullYear()}-${start.getMonth()}`,
      label: start.toLocaleDateString(undefined, { month: 'long', year: 'numeric' }),
      start,
      end,
    };
  });

export const getWeekOptions = (month: DateShortcut): DateShortcut[] => {
  const weeks: DateShortcut[] = [];
  let weekStart = new Date(month.start);

  while (weekStart <= month.end) {
    const weekEnd = new Date(weekStart);
    weekEnd.setDate(weekStart.getDate() + 6);
    weekEnd.setHours(23, 59, 59, 999);
    if (weekEnd > month.end) {
      weekEnd.setTime(month.end.getTime());
    }
    weeks.push({
      value: weekStart.toISOString(),
      label: `${formatDate(weekStart)} – ${formatDate(weekEnd)}`,
      start: new Date(weekStart),
      end: weekEnd,
    });
    weekStart = new Date(weekStart);
    weekStart.setDate(weekStart.getDate() + 7);
  }

  return weeks;
};

export const shortcutMatchesRange = (
  shortcut: { start: Date; end: Date },
  startDate: Date | null,
  endDate: Date | null
) => startDate?.getTime() === shortcut.start.getTime() && endDate?.getTime() === shortcut.end.getTime();

export const getUserLabel = (user: DashboardSmallUser) => {
  const name = [user.first_name, user.last_name].filter(Boolean).join(' ');
  return name ? `${name}${user.email ? ` (${user.email})` : ''}` : (user.email ?? `User ${user.id}`);
};
